export type Options = {
  event: string;
  ga_event_name: string;
  event_context?: string;
};

export const sendDataLayerEvent = (options: Options) => {
  if (window.dataLayer) {
    window.dataLayer.push({
      ...options,
    });
  }
};
